export const lockBody = () => {
  const body = document.body
  body.style.overflow = 'hidden'
  body.style.paddingRight = 'var(--scrollbar-width)'
  body.style.setProperty('--pos-right', 'var(--scrollbar-width)')
}

export const unlockBody = () => {
  const body = document.body
  body.style.overflow = ''
  body.style.paddingRight = ''
  body.style.setProperty('--pos-right', '0px')
}
